import type { FaireProductEntity } from "../../entity_types/product";

export const p_7cnva794nf: FaireProductEntity = {
  token: "p_7cnva794nf",
  type: "product",
  name: "Juniper Small Red / Everyday Wine / Cocktail Glass/ Set of 2",
  brandToken: "b_dtfc7uc37e",
  brandName: "Aaron Probyn US",
  imageUrl:
    "https://cdn.faire.com/fastly/21d1342b8dee1169528f3f5f3d6e4701eb3f8746fadfacdb3aaeffaa5ea6820b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7fc8cc4bc7250502a7488b260bcfa45a780992565c4633c9885f26a58321fc5e.jpeg",
    "https://cdn.faire.com/fastly/d84da831bfc9e02d26b19b7a8f0926e1a353b455e011bacdbf9a0caeff127d97.jpeg",
  ],
  priceDollars: 26.25,
  description:
    'Juniper is a sculptural glassware range designed to elevate the drinking experience by enhancing both flavour and aroma. The glasses are graphic in form yet functional and satisfying to use, and their striking geometric silhouette adds interest to any table, bar or drinks trolley.\n\nJuniper Small Red / Everyday Wine Glass\n• Dimension: Ø 8.6cm x H 17.3cm / Ø 3.4" x H 6.8"\n• Capacity: 265ml / 9 fl oz\n\n• Packed as a set of 2\n\n• Colour: clear',
  tags: [],
  msrpDollars: 52.5,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-05-04T23:53:20.469Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
